import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import {
    Table,
    TableFilter,
    BreadCrumb,
    FormElems,
    MleAdditionModal,
} from '../../components';

import { getFormData, getDraftTableData } from '../../utils/helperMethods';
import { ENTITY_TYPE, FORM_TYPE } from '../../utils/constants/commonValues';

import {
    fetchEntityRequest,
    fetchFormDetailsRequest,
    fetchFormInProcessRequest,
    setUniqueIdentifierRequest,
    fetchSurchargeSlabsRequest,
    fetchPaymentModesRequest,
    retryFailedMerchantFormRequest,
    resetRetryFormStore,
    fetchBDInprogressMerchantRequest,
    fetchEntityListRequest,
    addHeirarchyData,
    removeHeirarchyData,
    fetchEntityHierarchyRequest,
    resetFormInProcessData
} from './redux/merchantOnBoard.actions';

import { fetchPgConfigRequest } from './redux/pgConfig/pgConfig.actions';

// Local Components
import CreateMerchant from './CreateMerchant';
import EditViewMerchant from './EditViewMerchant';
import UserActionsMob from './UserActionsMob';
import DraftAction from './DraftAction';

// Styles
import './merchantOnboard.scss';
import BDInprogressAction from './BDInprogressAction';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { change } from 'redux-form';

const filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {},
    },
    {
        fieldType: 'select',
        label: 'Status',
        name: 'status',
        props: {
            placeholder: 'Status',
            data: [
                { name: 'Active', value: 'ACTIVE' },
                { name: 'Inactive', value: 'INACTIVE' },
                {
                    name: 'Inactive with settlement',
                    value: 'INACTIVE_WITH_SETTLEMENT',
                },
            ],
            labelField: 'name',
            valueField: 'value',
        },
    },
    // {
    //     fieldType: 'select',
    //     label: 'Onboarding Type',
    //     name: 'source',
    //     props: {
    //         placeholder: 'Select Onboarding Type',
    //         data: [
    //             { name: 'Axis Sourced Merchant', value: 'axis' },
    //             { name: 'Others', value: 'other' },
    //         ],
    //         label: 'Select Onboarding Type',
    //         labelField: 'name',
    //         valueField: 'value',
    //     },
    // },
    {
        fieldType: 'dynamic-select',
        name: 'merchantName',
        label: 'Merchant Name',
        props: {
            placeholder: 'Enter Merchant Name',
            data: [],
            labelField: 'name',
            valueField: 'entityCode',
        },
    },
    {
        fieldType: 'dynamic-select',
        name: 'merchantId',
        label: 'Merchant ID',
        props: {
            placeholder: 'Enter Merchant ID',
            data: [],
            labelField: 'entityCode',
            valueField: 'name',
        },
    },
    {
        fieldType: 'dynamic-select',
        name: 'mleName',
        label: 'MLE Name',
        props: {
            placeholder: 'Enter MLE Name',
            data: [],
            labelField: 'name',
            valueField: 'entityCode',
        },
    },
    {
        fieldType: 'dynamic-select',
        name: 'mleId',
        label: 'MLE ID',
        props: {
            placeholder: 'Enter MLE ID',
            data: [],
            labelField: 'entityCode',
            valueField: 'name',
        },
    },
    {
        fieldType: 'dynamic-select',
        name: 'partnerId',
        label: 'Partner Name',
        props: {
            placeholder: 'Enter Partner Name',
            data: [],
            labelField: 'name',
            valueField: 'entityCode',
        },
    },
    {
        fieldType: 'input',
        label: 'VPA',
        name: 'merchantVpa',
        props: {
            placeholder: 'Enter VPA',
        },
    },
    {
        fieldType: 'input',
        label: 'Registered Email',
        name: 'registeredEmail',
        props: {
            placeholder: 'Enter Email',
        },
    },
    {
        fieldType: 'input',
        label: 'Mobile',
        name: 'mobile',
        props: {
            placeholder: 'Enter Mobile Number',
        },
    },
];

const setEditData = (editData, merchantData) => {
    const {
        uniqueIdentifier: { uniqueId },
    } = merchantData;
    const formattedEditData = {
        type: FORM_TYPE.MERCHANT_ON_BOARD,
        uniqueIdentifier: uniqueId,
        sections: editData.sections,
    };
    return [formattedEditData];
};

// eslint-disable-next-line max-statements
const MerchantOnboard = props => {
    const {
        merchantData,
        history,
        match,
        actions,
        loader: { showLoader },
        editData,
        auth,
    } = props;

    const {
        error,
        tableData,
        isLoading,
        pagination,
        uniqueIdentifier: { uniqueId },
        formInProcess,
        merchantListLoading,
        mleListLoading,
        partnerListLoading,
        entityList,
    } = merchantData;

    // Extract 'permissions' directly from 'auth' and 'resourceDetails' objects.
    const {
        resourceDetails: { permissions },
    } = auth;

    const { forms } = formInProcess;

    const handleCreateMerchant = () => {
        setIsMleAdditionModal(true);
    };
    const [selectedMerchant, setSelectedMerchant] = useState(null);
    const [selectedMle, setSelectedMle] = useState(null);
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [filters, setFilters] = useState(filterFieldList);

    const columns = useMemo(
        () => [
            { header: 'Merchant Name', accessor: 'name' },
            { header: 'Merchant ID', accessor: 'entityCode' },
            // { header: 'AXIS MID', accessor: 'axisAcquiredMerchantId' },
            { header: 'Created Date', accessor: 'createdDate' },
            { header: 'Mode', accessor: 'mode' },
            { header: 'Status', accessor: 'status' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const columnsDraft = useMemo(
        () => [
            { header: 'Merchant Name', accessor: 'name' },
            { header: 'Email ID', accessor: 'merchantIdentifier' },
            // { header: 'AXIS MID', accessor: 'axisAcquiredMerchantId' },
            { header: 'Created Date', accessor: 'createdOn' },
            { header: 'Mode', accessor: 'keyMode' },
            { header: 'Status', accessor: 'status' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const columnsInactive = useMemo(
        () => [
            { header: 'Merchant Name', accessor: 'name' },
            { header: 'Merchant ID', accessor: 'entityCode' },
            // { header: 'AXIS MID', accessor: 'axisAcquiredMerchantId' },
            { header: 'Created Date', accessor: 'createdDate' },
            { header: 'Verification Status', accessor: 'verificationStatus' },
            { header: 'Status', accessor: 'status' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    useEffect(() => {
        actions.fetchFormDetailsRequest();
        actions.fetchPaymentModesRequest();
        actions.fetchPgConfigRequest();
        actions.fetchSurchargeSlabsRequest();
    }, [actions]);

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data

    const [pageCount, setPageCount] = useState(0);
    const [roleStatus, setRoleStatus] = useState('');
    const [filterData, setFilterData] = useState({});
    const [isResetPage, setIsResetPage] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [isMleAdditionModal, setIsMleAdditionModal] = useState(false);

    const fetchData = useCallback(
        ({ pageSize, pageIndex, roleStatus }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const data = { pageSize, pageIndex, roleStatus, sort: 'name' };
            actions.fetchEntityRequest({ ...data, ...filterData });
            setPageSize(pageSize);
        },
        [actions, filterData]
    );

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    const fetchDataDraft = useCallback(
        ({ pageSize, pageIndex, roleStatus }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            actions.fetchFormInProcessRequest();
        },
        [actions]
    );

    const fetchInactiveData = useCallback(
        ({ pageSize, pageIndex, roleStatus }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const data = {
                pageSize,
                pageIndex,
                roleStatus,
                sort: 'name',
                status: 'in:3',
            };
            actions.fetchBDInprogressMerchantRequest({
                ...data,
                ...filterData,
            });
            setPageSize(pageSize);
        },
        [actions, filterData]
    );

    const locationName = useHistory().location.pathname;

    useEffect(() => {
        if (locationName === '/mob') {
            // reset form data in process on listing page
            actions.resetFormInProcessData();
        }
    }, [locationName]);

    useEffect(() => {
        if (merchantData.retryForm.isSuccess) {
            fetchInactiveData({ pageIndex: 1, pageSize: 10 });
            setIsResetPage(true);
            actions.resetRetryFormStore();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [merchantData.retryForm.isSuccess]);

    const handleBackClick = () => {
        history.push('/mob');
        fetchData({ pageSize: 10, pageIndex: 1, roleStatus: '' });
    };

    const handleEditId = value => {
        actions.setUniqueIdentifierRequest(value || '', true);
    };

    const handleMleAdditionSubmit = data => {
        actions.addHeirarchyData(data);
        setIsMleAdditionModal(false);
        actions.setUniqueIdentifierRequest('', false);
        history.push('/mob/create/merchant');
    };

    const handleMleAdditionClose = () => {
        setIsMleAdditionModal(false);
    };
    

    useEffect(() => {
        actions.fetchEntityListRequest(ENTITY_TYPE.AGGREGATOR);
        actions.fetchEntityListRequest(ENTITY_TYPE.FRANCHISE);
        actions.fetchEntityListRequest(ENTITY_TYPE.MLE);
    }, [actions, isMleAdditionModal]);

    useEffect(() => {
        actions.removeHeirarchyData();
        actions.fetchEntityListRequest(ENTITY_TYPE.MERCHANT);
        actions.fetchEntityListRequest(ENTITY_TYPE.PARTNER);
    }, [actions]);

    useEffect(() => {
        filterFieldList.forEach(filter => {
            const { name, props } = filter;
    
            switch (name) {
                case 'merchantName':
                case 'merchantId':
                    props.defaultOption = selectedMerchant;
                    break;
    
                case 'mleName':
                case 'mleId':
                    props.defaultOption = selectedMle;
                    break;
    
                case 'partnerId':
                    props.defaultOption = selectedPartner;
                    break;
    
                default:
                    break;
            }
        });

        setFilters([...filterFieldList]);
    }, 
    [
        selectedMerchant, 
        selectedMle, 
        selectedPartner,  
        entityList?.merchant,
        entityList?.mle,
        entityList?.partner
    ]);

    useEffect(() => {
        const merchantOptions = entityList?.merchant || [];
        const mleOptions = entityList?.mle || [];
        const partnerOptions = entityList?.partner || [];
    
        filterFieldList.forEach(filter => {
            const { name, props } = filter;
    
            switch (name) {
                case 'merchantName':
                    props.data = merchantOptions;
                    props.optionsLoading = merchantListLoading;
                    props.onSearch = value =>
                        actions.fetchEntityListRequest(ENTITY_TYPE.MERCHANT, { entityName: value }, true);
                    props.onSelect = (option) => setSelectedMerchant(option);
                    break;
    
                case 'merchantId':
                    props.data = merchantOptions;
                    props.optionsLoading = merchantListLoading;
                    props.onSearch = value =>
                        actions.fetchEntityListRequest(ENTITY_TYPE.MERCHANT, { entityCode: value }, true);
                    props.onSelect = (option) => setSelectedMerchant(option);
                    break;
    
                case 'mleName':
                    props.data = mleOptions;
                    props.optionsLoading = mleListLoading;
                    props.onSearch = value =>
                        actions.fetchEntityListRequest(ENTITY_TYPE.MLE, { entityName: value }, true);
                    props.onSelect = (option) => setSelectedMle(option);
                    break;
    
                case 'mleId':
                    props.data = mleOptions;
                    props.optionsLoading = mleListLoading;
                    props.onSearch = value =>
                        actions.fetchEntityListRequest(ENTITY_TYPE.MLE, { entityCode: value }, true);
                    props.onSelect = (option) => setSelectedMle(option);
                    break;
    
                case 'partnerId':
                    props.data = partnerOptions;
                    props.optionsLoading = partnerListLoading;
                    props.onSearch = value =>
                        actions.fetchEntityListRequest(ENTITY_TYPE.PARTNER, { entityName: value }, true);
                    props.onSelect = (option) => setSelectedPartner(option);
                    break;
    
                default:
                    break;
            }
        });

        setFilters([...filterFieldList]);
    }, [
        entityList?.merchant,
        entityList?.mle,
        entityList?.partner,
        merchantListLoading,
        mleListLoading,
        partnerListLoading,
        actions
    ]);
    
    return (
        <div className="mob-wrapper">
            <Switch>
                <Route exact path="/mob">
                    <Table
                        id="merchant-edit"
                        tableTitle="Merchant Onboarding"
                        filterActionTitle="Add Merchant to Existing MLE"
                        // filterActionPermission="create_merchant_button"
                        filterActionPermission="create_merchant"
                        columns={columns}
                        isFiltersEnable
                        isPaginationEnable
                        data={tableData}
                        filterData={filterData}
                        error={error.errorMessage}
                        loading={showLoader || isLoading}
                        roleStatus={roleStatus}
                        pageCount={pageCount}
                        fetchData={fetchData}
                        numberOfRecord={
                            pagination && pagination.totalNumberOfRecords
                        }
                        pageSizeOptions={pageSizeOptions}
                        paginationLabel="Rows per page"
                        onClickTableAction={handleCreateMerchant}
                        setRoleStatus={setRoleStatus}
                        isResetPage={isResetPage}
                        afterResetPage={() => setIsResetPage(false)}
                        userActions={data => (
                            <UserActionsMob
                                data={data}
                                onSetId={handleEditId}
                            />
                        )}
                        pagePerView={3}
                        additionalActions={props => (
                            <div className={'table-additional-actions'}>
                                <DraftAction {...props} />
                                <BDInprogressAction {...props} />
                            </div>
                        )}
                        tableFilters={
                            <TableFilter
                                showOverlay
                                isResetFilterOnLoad
                                fieldsList={filters}
                                onSubmit={filterValues => {
                                    setFilterData(filterValues);
                                    setIsResetPage(true);
                                }}
                                onReset={resetValue => {
                                    setFilterData(resetValue);
                                    setIsResetPage(true);
                                    setSelectedMerchant(null);
                                    setSelectedMle(null);
                                    setSelectedPartner(null);
                                }}
                            />
                        }
                        tableActionPopup={null}
                    />
                    <MleAdditionModal
                        isOpen={isMleAdditionModal}
                        handleSubmit={handleMleAdditionSubmit}
                        handleClose={handleMleAdditionClose}
                        entityList={entityList}
                        actions={actions}
                    />
                </Route>
                <Route exact path="/mob/draft">
                    <Table
                        id="merchant-draft"
                        tableTitle="Merchant Onboarding"
                        filterActionTitle="Create Merchant"
                        filterActionPermission="create_merchant"
                        isFiltersEnable
                        columns={columnsDraft}
                        filterData={filterData}
                        data={getDraftTableData(merchantData.formInProcess)}
                        error={
                            (formInProcess.error &&
                                formInProcess.error.errorMessage) ||
                            ''
                        }
                        loading={showLoader || isLoading}
                        roleStatus={roleStatus}
                        pageCount={pageCount}
                        isResetPage={isResetPage}
                        afterResetPage={() => setIsResetPage(false)}
                        fetchData={fetchDataDraft}
                        numberOfRecord={
                            pagination && pagination.totalNumberOfRecords
                        }
                        pageSizeOptions={pageSizeOptions}
                        paginationLabel="Rows per page"
                        onClickTableAction={handleCreateMerchant}
                        setRoleStatus={setRoleStatus}
                        userActions={data => (
                            <UserActionsMob
                                data={data}
                                onSetId={handleEditId}
                                isEditOnly
                                tableType="draft"
                            />
                        )}
                        additionalActions={null}
                        tableSubSection={props => (
                            <BreadCrumb
                                {...props}
                                withBack
                                wrapperClass="draft-section"
                                onBackClick={handleBackClick}
                                title="Draft"
                                breadCrumbs={[
                                    {
                                        name: 'Merchant Onboarding',
                                        link: '/mob',
                                    },
                                    {
                                        name: 'Draft',
                                        link: '',
                                    },
                                ]}
                            />
                        )}
                        pagePerView={3}
                        tableActionPopup={null}
                    />
                </Route>
                <Route exact path="/mob/bd/inprogress">
                    <Table
                        tableTitle="Merchant Onboarding"
                        filterActionTitle="Create Merchant"
                        filterActionPermission="create_merchant"
                        isFiltersEnable
                        isPaginationEnable
                        columns={columnsInactive}
                        filterData={filterData}
                        data={tableData}
                        error={
                            (formInProcess.error &&
                                formInProcess.error.errorMessage) ||
                            ''
                        }
                        loading={showLoader || isLoading}
                        roleStatus={roleStatus}
                        pageCount={pageCount}
                        isResetPage={isResetPage}
                        afterResetPage={() => setIsResetPage(false)}
                        fetchData={fetchInactiveData}
                        numberOfRecord={
                            pagination && pagination.totalNumberOfRecords
                        }
                        pageSizeOptions={pageSizeOptions}
                        paginationLabel="Rows per page"
                        onClickTableAction={handleCreateMerchant}
                        setRoleStatus={setRoleStatus}
                        userActions={data => (
                            <UserActionsMob
                                data={data}
                                reduxActions={actions}
                                tableType="inactive"
                                isEditOnly
                                onSetId={handleEditId}
                            />
                        )}
                        additionalActions={null}
                        tableSubSection={props => (
                            <BreadCrumb
                                {...props}
                                withBack
                                wrapperClass="inactive-section"
                                onBackClick={handleBackClick}
                                title="BD Inprogress"
                                breadCrumbs={[
                                    {
                                        name: 'Merchant Onboarding',
                                        link: '/mob',
                                    },
                                    {
                                        name: 'BD In progress',
                                        link: '',
                                    },
                                ]}
                            />
                        )}
                        pagePerView={3}
                        tableActionPopup={null}
                    />
                </Route>
                <Route path="/mob/create/:boardingType">
                    <CreateMerchant
                        history={history}
                        match={match}
                        data={merchantData}
                        draftData={getFormData(
                            FORM_TYPE.MERCHANT_ON_BOARD,
                            forms,
                            uniqueId
                        )}
                        permissions={permissions}
                    />
                </Route>
                <Route path="/mob/draft/:boardingType/:merchantId">
                    <EditViewMerchant
                        history={history}
                        match={match}
                        data={merchantData}
                        editData={getFormData(
                            FORM_TYPE.MERCHANT_ON_BOARD,
                            setEditData(editData, merchantData),
                            uniqueId
                        )}
                        permissions={permissions}
                    />
                </Route>
                <Route path="/mob/draft/view/:boardingType/:merchantId">
                    <EditViewMerchant
                        history={history}
                        match={match}
                        data={merchantData}
                        editData={getFormData(
                            FORM_TYPE.MERCHANT_ON_BOARD,
                            setEditData(editData, merchantData),
                            uniqueId
                        )}
                        permissions={permissions}
                    />
                </Route>
            </Switch>
        </div>
    );
};

const mapStateToProps = ({ auth, merchantData, form, loader, editData }) => ({
    auth,
    merchantData,
    form,
    loader,
    editData,
    formData: form['table-filter'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchEntityRequest,
            fetchFormDetailsRequest,
            fetchFormInProcessRequest,
            setUniqueIdentifierRequest,
            fetchPaymentModesRequest,
            fetchPgConfigRequest,
            fetchSurchargeSlabsRequest,
            retryFailedMerchantFormRequest,
            resetRetryFormStore,
            fetchBDInprogressMerchantRequest,
            fetchEntityListRequest,
            addHeirarchyData,
            removeHeirarchyData,
            fetchEntityHierarchyRequest,
            resetFormInProcessData
        },
        dispatch
    ),
    change: (field, value) => dispatch(change('table-filter', field, value)),
});

MerchantOnboard.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    merchantData: PropTypes.object,
    editData: PropTypes.object,
    loader: PropTypes.object,
    formData: PropTypes.object,
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MerchantOnboard)
);
